import type { ReactNode } from 'react';
import styles from './RequiredLabel.module.css';

export interface RequiredLabelProps {
  label: ReactNode;
  required?: boolean;
}

export const RequiredLabel = ({ label, required = true }: RequiredLabelProps) => {
  return (
    <>
      {label}
      {required && <span className={styles.required}>*</span>}
    </>
  );
};
